import { render, staticRenderFns } from "./DiscoverSettings.vue?vue&type=template&id=66501542&"
import script from "./DiscoverSettings.vue?vue&type=script&lang=js&"
export * from "./DiscoverSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports